import { Buffer } from "buffer";

class File {
  constructor(api) {
    this.api = api;
  }

  async getFiles() {
    return await this.api.call('/files');
  }

  async getInfoSeries() {
    return await this.api.call('/infoSeries');
  }

  async getChildFiles(path) {
    const fileId = this.buildFileId(path);
    
    return await this.api.call('/files/' + fileId);
  }

  buildFileId(path) {
    return Buffer.from(path).toString('hex');
  }

  async getDownloadURL(path) {
    const fileId = this.buildFileId(path);

    return await this.api.call('/files/' + fileId + '/link');
  }

  async getUploadURL(path) {
    const fileId = this.buildFileId(path);

    return await this.api.call('/files/' + fileId + '/upload');
  }

  async addPath(path) {
    return await this.api.call('/files', 'POST', {key: path})
  }

  async deletePath(path) {
    const fileId = this.buildFileId(path);
    return await this.api.call('/files/' + fileId, 'DELETE');
  }

  async rename(from, to) {
    const fileId = this.buildFileId(from);
    return await this.api.call('/files/' + fileId, 'PATCH', {
      path: to,
      action: 'rename'
    });
  }

  async copy(from, to) {
    const fileId = this.buildFileId(from);
    return await this.api.call('/files/' + fileId, 'PATCH', {
      path: to,
      action: 'copy'
    });
  }

  async copyFromInfoSeries(fileNames, to) {
    return await this.api.call('/infoSeries', 'PATCH', {
      toFolder: to, // toFolder
      fileNames: fileNames
    });
  }

  async upload(file, url) {
    const options = {
      headers: this.api.headers(),
      method: 'PUT',
      mode: 'cors',
      body: file
    };

    return await fetch(url, options)
      .then(this.api.checkStatus);
  }
}

export default File;


// WEBPACK FOOTER //
// ./src/libs/File.js